function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import $ from 'jquery';
import FullscreenItemPreload from './fullscreenItemPreload.js';
import { utils } from '../utils';
import { window } from '@wix/photography-client-lib'; // eslint-disable-next-line import/no-unresolved

import playIcon from '-!svg-react-loader!../assets/images/video/play.svg'; // eslint-disable-next-line import/no-unresolved

import pauseIcon from '-!svg-react-loader!../assets/images/video/pause.svg'; // eslint-disable-next-line import/no-unresolved

import loaderIcon from '-!svg-react-loader!../assets/images/video/fa-circle-o-notch.svg';
import FULLSCREEN_EVENTS from '../constants/fullscreenEvents';

var FullscreenVideo = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FullscreenVideo, _React$Component);

  function FullscreenVideo(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.props.actions.eventsListener(FULLSCREEN_EVENTS.ITEM_CREATED);

    _this.state = {
      buffering: false,
      duration: 0,
      volume: 0.8,
      playing: true,
      played: 0,
      loaded: false,
      mute: false,
      reactPlayerLoaded: false,
      vimeoPlayerLoaded: false,
      hlsPlayerLoaded: false
    };

    if (!utils.isSSR()) {
      if (!(window && window.ReactPlayer)) {
        import(
        /* webpackChunkName: "react-player" */
        'react-player').then(function (ReactPlayer) {
          window.ReactPlayer = ReactPlayer["default"];

          _this.setState({
            reactPlayerLoaded: true
          });
        });
      }

      if ( //Vimeo player must be loaded by us, problem with requireJS
      !(window && window.Vimeo) && props.item.videoUrl && props.item.videoUrl.includes('vimeo.com')) {
        import(
        /* webpackChunkName: "vimeo-react-player" */
        '@vimeo/player').then(function (Player) {
          window.Vimeo = {
            Player: Player["default"]
          };

          _this.setState({
            vimeoPlayerLoaded: true
          });
        });
      }

      if ( //Hls player must be loaded by us, problem with requireJS
      !(window && window.Hls) && _this.isHLSVideo()) {
        import(
        /* webpackChunkName: "HlsPlayer" */
        'hls.js').then(function (Player) {
          window.Hls = Player["default"];

          _this.setState({
            hlsPlayerLoaded: true
          });
        });
      }
    }

    _this.handleArrowKeys = _this.handleArrowKeys.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = FullscreenVideo.prototype;

  _proto.isHLSVideo = function isHLSVideo() {
    return this.props.item.videoUrl && (this.props.item.videoUrl.includes('/hls') || this.props.item.videoUrl.includes('.m3u8'));
  };

  _proto.shouldUseHlsPlayer = function shouldUseHlsPlayer() {
    return this.isHLSVideo() && !utils.isiOS();
  };

  _proto.shouldForceVideoForHLS = function shouldForceVideoForHLS() {
    return this.isHLSVideo() && utils.isiOS();
  };

  _proto.fixIFrameTabIndexIfNeeded = function fixIFrameTabIndexIfNeeded() {
    if (this.props.item.metadata.isExternal) {
      var videoGalleryItem = window.document && window.document.getElementById("fullscreen-video-" + this.props.item.id);
      var videoIFrames = videoGalleryItem && videoGalleryItem.getElementsByTagName('iframe');
      var videoIFrame = videoIFrames && videoIFrames[0];

      if (videoIFrame) {
        if (this.props.isDisplayed) {
          //isDisplayed={this.props.current.idx === idx}
          videoIFrame.setAttribute('tabIndex', '0');
        } else {
          videoIFrame.setAttribute('tabIndex', '-1');
        }
      }
    }
  };

  _proto.clickOffset = function clickOffset(e) {
    var element = e.currentTarget;
    var clickOffsetInElement = e.pageX - $(element).offset().left;
    var elementWidth = element.getBoundingClientRect().width;
    return clickOffsetInElement / elementWidth;
  };

  _proto.seekTo = function seekTo(e) {
    var played = this.clickOffset(e);
    this.video.seekTo(played);
    this.setState({
      played: played
    });
  };

  _proto.changeVideoLocation = function changeVideoLocation(diff) {
    var played = this.state.played + diff;
    this.video.seekTo(played);
    this.setState({
      played: played
    });
  };

  _proto.setVolume = function setVolume(e) {
    this.setState({
      volume: this.clickOffset(e),
      mute: false
    });
  };

  _proto.changeVolume = function changeVolume(diff) {
    this.setState({
      volume: this.state.volume + diff,
      mute: false
    });
  };

  _proto.togglePlay = function togglePlay() {
    this.state.playing ? this.pause() : this.play();
  };

  _proto.isExternalMobileVideo = function isExternalMobileVideo() {
    return utils.isMobile() && !this.props.isDummy && this.props.item.metadata.isExternal;
  };

  _proto.secondsToTimeString = function secondsToTimeString(seconds) {
    if (!(seconds >= 0)) {
      //could also be NaN
      seconds = 0;
    }

    var hourFixer = seconds >= 3600 ? 3 : 0;
    return new Date(seconds * 1000).toISOString().substr(14 + hourFixer, 5 + hourFixer);
  } // onProgress({ loaded, played }) {
  //   this.setState({ loaded, played });
  // }
  ;

  _proto.play = function play() {
    this.setState({
      playing: true,
      playedOnce: true
    });
  };

  _proto.pause = function pause() {
    this.setState({
      playing: false
    });
  };

  _proto.autoPlay = function autoPlay() {
    if (this.props.isDisplayed) {
      this.play();
    } else if (!this.props.isDummy) {
      this.pause();
    }
  };

  _proto.handleArrowKeys = function handleArrowKeys(e) {
    if (!utils.isAccessibilityEnabled() || !this.props.isDisplayed) {
      //the keypress events are only effective when the video is displayed
      return true;
    }

    var activeControl = null;
    var activeControlClassName = document.activeElement.className || '';

    if (activeControlClassName.indexOf('fullscreen-video-controls-progress') >= 0) {
      activeControl = 'progressBar';
    } else if (activeControlClassName.indexOf('fullscreen-video-controls-volume-bar') >= 0) {
      activeControl = 'volumeBar';
    }

    switch (e.keyCode || e.charCode) {
      case 38:
        //up
        if (activeControl === 'volumeBar') {
          e.preventDefault();
          e.stopPropagation();
          this.changeVolume(0.1);
        }

        return false;

      case 40:
        //down
        if (activeControl === 'volumeBar') {
          e.preventDefault();
          e.stopPropagation();
          this.changeVolume(-0.1);
        }

        return false;

      case 37:
        //left
        if (activeControl === 'progressBar') {
          e.preventDefault();
          e.stopPropagation();
          this.changeVideoLocation(-0.1);
        }

        return false;

      case 39:
        //right
        if (activeControl === 'progressBar') {
          e.preventDefault();
          e.stopPropagation();
          this.changeVideoLocation(0.1);
        }

        return false;

      default:
        break;
    }

    return true;
  };

  _proto.stopPropagation = function stopPropagation(event) {
    event.stopPropagation();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.video.stopBuffering) {
      this.video.stopBuffering();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.autoPlay();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.isDisplayed !== this.props.isDisplayed) {
      this.autoPlay();
    }

    if (prevProps.currentIdx !== this.props.currentIdx) {
      this.fixIFrameTabIndexIfNeeded();
    }
  };

  _proto.onWrapperClick = function onWrapperClick() {
    if (utils.isMobile() && !this.props.isDummy && !this.state.playedOnce) {
      this.setState({
        playedOnce: true
      });
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    if (!(window && window.ReactPlayer)) {
      return null;
    }

    var PlayerElement = window.ReactPlayer;
    var _this$state = this.state,
        playing = _this$state.playing,
        volume = _this$state.volume,
        played = _this$state.played,
        buffering = _this$state.buffering,
        mute = _this$state.mute,
        duration = _this$state.duration;
    var _this$props = this.props,
        item = _this$props.item,
        isDummy = _this$props.isDummy,
        isDisplayed = _this$props.isDisplayed;
    var innerStyle = {
      width: item.width + 'px',
      height: item.height + 'px'
    };
    var controlsSize = '20';
    var videoControls = /*#__PURE__*/React.createElement("div", {
      className: 'fullscreen-video-controls ' + (utils.isMobile() ? 'pro-fullscreen-mobile ' : '') + (utils.isMobile() && !utils.isiOS() ? 'fullscreen-video-controls-mobile-android' : ''),
      style: innerStyle
    }, /*#__PURE__*/React.createElement("div", {
      onClick: this.togglePlay.bind(this),
      className: "fullscreen-video-controls-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "fullscreen-video-controls-bar",
      onClick: this.stopPropagation
    }, /*#__PURE__*/React.createElement("button", {
      className: 'cursor-pointer fullscreen-video-controls-play',
      onClick: this.togglePlay.bind(this),
      tabIndex: isDisplayed ? utils.getTabIndex('fullscreenVideoPlay') : -1,
      "aria-label": "Play, toggle"
    }, buffering ? loaderIcon({
      className: 'pro-fullscreen-loader',
      width: controlsSize,
      height: controlsSize,
      viewBox: '0 0 14 14'
    }) : playing ? pauseIcon({
      width: controlsSize,
      height: controlsSize,
      viewBox: '0 0 11 10'
    }) : playIcon({
      width: controlsSize,
      height: controlsSize,
      viewBox: '0 0 12 15'
    })), /*#__PURE__*/React.createElement("div", {
      className: "cursor-pointer fullscreen-video-controls-progress",
      onClick: this.seekTo.bind(this),
      tabIndex: isDisplayed ? utils.getTabIndex('fullscreenVideoBar') : -1,
      "aria-label": "Video Progress Bar, (" + (Math.round(played * 10) * 10 + '%') + ")",
      "aria-live": "polite",
      onKeyDown: this.handleArrowKeys,
      role: "progressbar"
    }, /*#__PURE__*/React.createElement("div", {
      className: "fullscreen-video-controls-progress pro-fullscreen-fill",
      style: {
        width: played * 100 + '%'
      }
    })), /*#__PURE__*/React.createElement("span", {
      className: "fullscreen-video-controls-time"
    }, this.secondsToTimeString(duration * played)), /*#__PURE__*/React.createElement("span", {
      className: "fullscreen-video-controls-slash"
    }, "/"), /*#__PURE__*/React.createElement("span", {
      className: "fullscreen-video-controls-time"
    }, this.secondsToTimeString(duration)), /*#__PURE__*/React.createElement("button", {
      className: 'cursor-pointer fullscreen-video-controls-volume-icon progallery-svg-font-icons-volume',
      onClick: function onClick() {
        _this2.setState({
          mute: !mute
        });
      },
      tabIndex: isDisplayed ? utils.getTabIndex('fullscreenVideoMute') : -1,
      "aria-label": "" + (this.state.mute ? 'Unmute' : 'Mute')
    }), /*#__PURE__*/React.createElement("div", {
      className: "cursor-pointer fullscreen-video-controls-volume-bar",
      onClick: this.setVolume.bind(this),
      tabIndex: isDisplayed ? utils.getTabIndex('fullscreenVideoVolume') : -1,
      "aria-label": "Volume Controller",
      "aria-live": "polite",
      onKeyDown: this.handleArrowKeys,
      role: "progressbar"
    }, /*#__PURE__*/React.createElement("div", {
      className: "fullscreen-video-controls-volume-bar pro-fullscreen-fill",
      style: {
        width: (mute ? 0 : volume * 100) + '%'
      }
    })))));
    var videoOverlay = utils.isMobile() ? /*#__PURE__*/React.createElement("div", {
      className: "fullscreen-mobile-external-video-overlay",
      style: {
        height: item.height * 0.7,
        width: item.width
      },
      onTouchEnd: function onTouchEnd() {
        return _this2.togglePlay();
      }
    }) : '';
    var configs = this.isExternalMobileVideo() ? {
      youtubeConfig: {
        playerVars: {
          playsinline: 0
        }
      },
      vimeoConfig: {
        iframeParams: {
          playsinline: 0
        }
      }
    } : '';
    var url = item.videoUrl ? item.videoUrl : item.createUrl('resized', 'video');
    var isMobileExternalVideoPlayed = item.metadata.isExternal && this.state.playedOnce && utils.isMobile();
    return !isDummy ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FullscreenItemPreload, {
      item: item,
      scale: this.props.currentWindow.scale.min(item),
      loaded: this.state.loaded
    }), /*#__PURE__*/React.createElement("div", {
      "data-hook": "fullscreen-video",
      className: 'fullscreen-content  fullscreen-item fullscreen-item-video fullscreen-item-' + item.idx + (utils.isiOS() ? ' pro-fullscreen-ios' : ''),
      style: _objectSpread(_objectSpread({}, innerStyle), {}, {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }),
      key: 'video_container'
    }, /*#__PURE__*/React.createElement(PlayerElement, _extends({
      url: url,
      "aria-label": item.alt ? item.alt : 'untitled video',
      alt: item.alt ? item.alt : 'untitled video',
      loop: !!this.props.styles.videoLoop,
      width: item.width,
      height: item.height,
      className: 'fullscreen-video fullscreen-video-' + item.idx,
      id: "fullscreen-video-" + this.props.item.id,
      style: innerStyle,
      ref: function ref(video) {
        _this2.video = video;
      },
      playing: isDisplayed && playing,
      volume: mute ? 0 : volume,
      onReady: function onReady() {
        _this2.setState({
          loaded: true
        });

        _this2.fixIFrameTabIndexIfNeeded();

        console.log('fullscreen video onReady itemId: ' + item.idx);
      } //checking the only the correct video is loading
      ,
      onStart: function onStart() {
        return console.log('fullscreen video onStart itemId: ' + item.idx);
      },
      onPlay: function onPlay() {
        return _this2.setState({
          playing: true
        });
      },
      onPause: function onPause() {
        return _this2.setState({
          playing: false
        });
      },
      onBuffer: function onBuffer(buffering) {
        return _this2.setState({
          buffering: buffering
        });
      },
      onEnded: function onEnded() {
        return !!_this2.props.styles.videoLoop || _this2.setState({
          playing: false
        });
      },
      onError: function onError(e) {
        return console.log('onError', e);
      },
      onProgress: function onProgress(_ref) {
        var played = _ref.played;
        return _this2.setState({
          played: played
        });
      },
      onDuration: function onDuration(duration) {
        return _this2.setState({
          duration: duration
        });
      },
      onWrapperClick: this.onWrapperClick.bind(this),
      playbackRate: this.props.styles.videoSpeed || 1,
      config: {
        file: {
          attributes: {
            poster: item.createUrl('resized', 'img')
          },
          forceHLS: this.shouldUseHlsPlayer(),
          forceVideo: this.shouldForceVideoForHLS()
        }
      },
      controls: item.metadata.isExternal || utils.isiOS()
    }, configs)), this.isExternalMobileVideo() || playing ? '' : /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        _this2.togglePlay();
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: 'cursor-pointer fullscreen-item-video-play progallery-svg-font-icons-play-triangle  ' + (item.metadata.isExternal ? ' pro-fullscreen-external' : '')
    }), /*#__PURE__*/React.createElement("i", {
      className: 'cursor-pointer fullscreen-item-video-play progallery-svg-font-icons-play-background ' + (item.metadata.isExternal ? ' pro-fullscreen-external' : '')
    })), videoOverlay, item.metadata.isExternal ? '' : videoControls)) :
    /*#__PURE__*/
    // slides on the left or right
    React.createElement("div", null, /*#__PURE__*/React.createElement(FullscreenItemPreload, {
      item: item,
      scale: this.props.currentWindow.scale.min(item),
      loaded: this.state.loaded
    }), /*#__PURE__*/React.createElement("video", {
      preload: "none",
      width: item.width,
      height: item.height,
      poster: item.createUrl('resized', 'img'),
      className: 'fullscreen-item fullscreen-video-' + this.props.item.idx,
      key: 'video',
      style: innerStyle,
      ref: function ref(video) {
        _this2.video = video;
      },
      "aria-label": item.alt ? item.alt : 'untitled video'
    }, /*#__PURE__*/React.createElement("source", {
      src: item.createUrl('resized', 'video'),
      type: "video/mp4"
    })));
  };

  return FullscreenVideo;
}(React.Component);

export default FullscreenVideo;